(function () {
  const productSlider = () => {
    $(document).ready(function () {
      $(".js-get-section").each(function (index, parent) {
        let parentId = `#${$(parent).attr("id")}`;

        let carousel = document
          .querySelector(parentId)
          .querySelector(`.js-swiper-product-carousel`);

        let scrollBar = document
          .querySelector(parentId)
          .querySelector(`.js-product-carousel-swiper-scrollbar`);

        let prev = document
          .querySelector(parentId)
          .querySelector(`.js-product-carousel-arrow-prev`);

        let next = document
          .querySelector(parentId)
          .querySelector(`.js-product-carousel-arrow-next`);

        const slideCount = carousel.querySelectorAll(".swiper-slide").length;
        const speed = slideCount > 30 ? 0 : 800;
        // Free mode drives its edge corrections off params.speed, and this
        // section sets speed to 0 on big carousels (the collection can render
        // 50 cards / 400+ slides). Speed 0 made every edge correction jump in
        // one frame, so touch widths get a real duration to animate over.
        const touchSpeed = 400;

        let swiperCarousel = new Swiper(carousel, {
          speed: touchSpeed,
          slidesPerView: 1.2,
          spaceBetween: 20,
          slidesOffsetAfter: 20,
          // Touch widths (<990px) scroll freely: a swipe coasts and settles
          // wherever the finger left it instead of snapping to the next card.
          // Momentum is damped hard (coast distance scales with momentumRatio
          // x momentumVelocityRatio) because an undamped flick coasted ~8
          // cards and could cross most of the track, forcing dozens of cards
          // and their lazy images to paint at once. Bounce is off: it settles
          // via params.speed, which is 0 here. Desktop keeps the snap so the
          // arrows land on whole slides. Every breakpoint states freeMode
          // explicitly because Swiper merges breakpoint params over whatever
          // the previous breakpoint set.
          freeMode: {
            enabled: true,
            sticky: false,
            momentumRatio: 0.5,
            momentumVelocityRatio: 0.5,
            momentumBounce: false,
          },
          scrollbar: {
            el: scrollBar,
            draggable: true,
          },
          navigation: {
            prevEl: prev,
            nextEl: next,
          },
          breakpoints: {
            750: {
              speed: touchSpeed,
              slidesPerView: 1.2,
              spaceBetween: 20,
              slidesOffsetAfter: 0,
              freeMode: {
                enabled: true,
                sticky: false,
                momentumRatio: 0.5,
                momentumVelocityRatio: 0.5,
                momentumBounce: false,
              },
            },
            990: {
              speed: speed,
              slidesPerView: 2,
              spaceBetween: 24,
              slidesOffsetAfter: 0,
              freeMode: { enabled: false },
            },
            1100: {
              speed: speed,
              slidesPerView: 3,
              spaceBetween: 24,
              slidesOffsetAfter: 0,
              freeMode: { enabled: false },
            },
          },
        });

        if (
          $(".js-product-carousel-arrow-prev").hasClass("swiper-button-lock") ||
          $(".js-product-carousel-arrow-next").hasClass("swiper-button-lock")
        ) {
          $(".product-carousel_nav-tools").css("display", "none");
        }
      });
    });
  };

  document.addEventListener("DOMContentLoaded", function () {
    productSlider();
    document.addEventListener("shopify:section:load", function () {
      productSlider();
    });
  });
})();
